module.exports = __webpack_public_path__ + "img/diamante.3ee26d1d.png";